import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { getImage } from '@common/lib/images';
import { getText } from '@common/lib/text';

import { timeStringFormat } from '@/common/lib/timer';
import { type PlantTypeText } from '@/common/types/plant';
import { type ResourceTypeText } from '@/common/types/resource';

import { StringSmall } from '../Typography/Typography';
import { Picture } from '../ui/Picture/Picture';
import { SecondaryTimer } from '../ui/Timer/SecondaryTimer';

import css from './styles.module.scss';

interface ActiveBoostItemProps {
  itemName: ResourceTypeText | PlantTypeText | string;
  effectMultiplier: number;
  seconds: number;
}

const ActiveBoostItem: FC<ActiveBoostItemProps> = ({
  effectMultiplier,
  itemName,
  seconds,
}) => {
  const { t } = useTranslation();
  const factoryName = getText({ name: itemName, kind: 'build', t });
  const image = getImage({ name: itemName, field: 'build' });

  return (
    <li className="w-full flex items-center justify-between py-1 border-t border-white/20">
      <div className="flex items-center gap-2">
        <Picture
          className="min-w-[32px] min-h-[32px] w-[32px] h-[32px]"
          img={image?.img}
          webp={image?.webp}
          alt={itemName}
        />
        <StringSmall weight="bold">{factoryName}</StringSmall>
      </div>
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2">
          <StringSmall weight="medium" className="!text-white/40">
            {t('Speed')}
          </StringSmall>
          <StringSmall weight="medium">{`x${effectMultiplier}`}</StringSmall>
        </div>
        <SecondaryTimer
          className={css.timer}
          value={timeStringFormat(seconds * 1000)}
          variant="boost"
        />
      </div>
    </li>
  );
};

export { ActiveBoostItem };
